// extracted by css-extract-rspack-plugin
export default {"container":"Mh6ii","singleColumn":"D4FpG","leftColumn":"lEQKq","rightColumn":"hdu4Y","UpsellPageContent":"r6oef"};